import React from 'react';

import HowItWorksStep1SVG from "../../components/Images/HowItWorksStep1SVG"
import HowItWorksStep2SVG from "../../components/Images/HowItWorksStep2SVG"
import HowItWorksStep3SVG from "../../components/Images/HowItWorksStep3SVG"
import HowItWorksStep4SVG from "../../components/Images/HowItWorksStep4SVG"
import  KavitaImg from "../../pages/WritersBenefit/Author/Images/Kavita.jpg"
import  WordsImg from "../../pages/WritersBenefit/Author/Images/Words.jpg"
import  AnandImg from "../../pages/WritersBenefit/Author/Images/Anand.jpg"
import NewNovelDesktop from '../../pages/WritersBenefit/Author/Images/NewNovel.svg'
import DailyUploadDesktop from '../../pages/WritersBenefit/Author/Images/DailyUpload.svg'
import CompletionBonusDesktop from '../../pages/WritersBenefit/Author/Images/CompletionBonus.svg'
import RevenueSvg from '../../pages/WritersBenefit/Author/Images/Revenue.svg'


const hindiUGC = {
  introduction_heading :'लेखक बनने के अपने सपने को करें साकार!',
  create_novel_button_text: "अभी अपना नया उपन्यास प्रकाशित करें| ",
  video_thumbnail_desktop: 'https://djhonz7dexnot.cloudfront.net/544fdd9bda03520310c8ecc7476e9eb0414c113d.jpg',
  video_thumbnail_mobile: 'https://djhonz7dexnot.cloudfront.net/0242ea4cf53b5e184215c8de5e2db6eaf1ec0631.jpg',
  revenue: {
    heading: 'न्यूनतम 25% का लाइफटाइम रेवेन्यू शेयर किया जाएगा।',
    image: RevenueSvg,
    subHeading: <>आपकी ऑडियो सीरीज़ अगर राइटर बेनिफिट प्रोग्राम में चुनी जाती है तो, तो आप लाईफटाइम इस पुरस्कार के पात्र हो जाएंगे।</>,
    extraNotes: [
      {
        no: 1,
        text: 'आय का न्यूनतम 25% रिवेन्यू टैक्स और भुगतान गेटवे शुल्कों की कटौती के बाद ही लेखकों के साथ शेयर किया जाएगा।',
      },
      {
        no: 2,
        text: 'किसी भी महीने का रिवेन्यू, अगले महीने के पहले दिन ही आपके आय टैब में एड कर दिया जाएगा।',
      },
      {
        no: 3,
        text: 'हम आपके आय टैब में आपकी रिवेन्यू राशि जोड़ते रहेंगे, लेकिन आपकी रेवेन्यू राशि कम से कम ₹100 होने के बाद ही आप अपनी इस आय को अपने बैंक एकाउंट में स्थानांतरित कर सकते है।',
      },
    ],
  },
  new_novel_bonus: {
    heading: '1. न्यू सीरीज़ बोनस प्लान 🖋️',
    image: NewNovelDesktop,
    subHeading: <>कम से कम ₹3000 तक की धनराशि पाएं। </>,
    tableHeadings: ['न्यूनतम शब्द ', 'न्यूनतम इनाम 💰'],
    table: [
      {
        wordCount: '30,000',
        reward: '₹3000',
      },
    ],
    note: <>कॉपिड, अनुवादित, अश्लील या गैर-काल्पनिक कंटेंट को अनुमति नहीं है। </>,
    extraNotes: [
      {
        no: 1,
        text: 'लेखक को राइटर बेनिफिट प्रोग्राम (WBP) के लिए आवेदन करना होगा।',
      },
      {
        no: 2,
        text: 'यदि ऑडियो सीरीज़ हमारे कंटेंट गुणवत्ता मानकों की शर्ते पूरा करती है, तो ही आपके एप्लीकेशन को अप्रूव किया जाएगा।',
      },
      {
        no: 3,
        text: 'एप्लीकेशन अप्रूवल के समय, पुरस्कार को लेखक के आय टैब में जोड़ दिया जाएगा।',
      },
      {
        no: 4,
        text: <>पुरस्कार राशि एप्लीकेशन अप्रूवल के समय प्रकाशित शब्दों पर आधारित होगी और इसकी गणना 10 पैसे प्रति शब्द की दर से की जाएगी।
        <br/>उदाहरण: यदि अप्रूवल के समय कहानी में ५०,००० शब्द हैं, तो इनाम की राशि ५ हज़ार रुपये होगी।</>,
      },
      {
        no: 5,
        text: "कान्ट्रैक्ट साइन करने के बाद ही लेखक वॉलेट से पैसे अपने बैंक अकाउंट में ट्रांसफर करने के पात्र होंगे। भुगतान चक्र अगले महीने के पहले सप्ताह में शुरू होता है।",
      },
      {
        no: 6,
        text: "ऑडियो सीरीज़ का रिव्यू करते समय यदि कंटेंट कॉपिड, अनुवादित आदि पाया जाता है, तो हम पुरस्कार राशि को अस्वीकार करने या पुनः प्राप्त करने का अधिकार सुरक्षित रखते है।",
      },
    ],
  },
  daily_update_bonus : {
    heading: '2. डेली अपडेट बोनस ⭐',
    image: DailyUploadDesktop,
    subHeading: <>यह इनाम 10 पैसे/शब्द की प्रोत्साहन राशि पर, प्रतिदिन 2,000 शब्दों तक के लिए जेनरेट किया जाता है। श्रोताओं रोज़ाना एपिसोड अपडेट चाहते है इसलिए, यदि आप नियमित रूप से एपिसोड पब्लिश करते है तो हम आपको अधिक भुगतान करेंगे। लेकिन यदि आप किसी भी दिन एपिसोड पब्लिश करने से चूक जाते है भुगतान राशि कम कर दी जायेगी।</>,
    tableHeadings: ['प्रोत्साहन प्रकार', 'प्रोत्साहन दर 💰'],
    table: [
      {
        wordCount: <span style={{color: '#54B585'}} >पूर्ण प्रोत्साहन</span>,
        reward: <> <span style={{color: '#54B585'}}>100%</span> प्रोत्साहन राशि <br /> = 10 पैसे/शब्द  </>,
      },
      {
        wordCount: <span style={{color: '#799E22'}} >स्ट्रीक प्रोत्साहन</span>,
        reward: <><span style={{color: '#799E22'}}>150%</span> प्रोत्साहन राशि <br /> = 15 पैसे/शब्द</>,
      },
      {
        wordCount: <span style={{color: '#F2C602'}} >आधा प्रोत्साहन</span>,
        reward: <><span style={{color: '#F2C602'}}>50%</span> प्रोत्साहन राशि <br /> = 5 पैसे/शब्द</>,
      },
      {
        wordCount: <span style={{color: '#E51A4D'}} >अनुपस्थित दिन</span>,
        reward: <>कोई भुगतान <span style={{color: '#E51A4D'}}>नहीं</span></>,
      },
     
    ],
    note: <>यदि आपके ऑडियो सीरीज़ से श्रोताओं काम हो जाते है तो यह इनाम रोक दिया जाएगा</>,
    extraNotes: [
      {
        no: 1,
        text: <> यह इनाम का स्ट्रक्चर लूडो के &apos;सांप और सीढ़ी&apos; खेल जैसा है। प्रोत्साहन प्रकार (कम/ज्यादा) इस बात पर निर्भर करता है, कि WBP कान्ट्रैक्ट अप्रूव होने के बाद किस तरह से शब्द सीमा को मैन्टैन रखा है। </>,
      },
      {
        no: 2,
        text: <> हमारा <strong>पूर्ण प्रोत्साहन</strong> 10 पैसे/शब्द है <br />
        उदाहरण के लिए, <br/>
        -यदि आपने 1 अक्टूबर से 6 अक्टूबर तक प्रतिदिन 2000 शब्दों के एपिसोड प्रकाशित किए हैं;<br/>
        तो 1 अक्टूबर से 6 अक्टूबर तक <strong>पूर्ण प्रोत्साहन</strong> (10 पैसे/शब्द) मिलेगा, इसलिए आपको प्रत्येक दिन ₹200 प्राप्त होंगे।.</>,
      },
      {
        no: 3,
        text: <> प्रोग्राम की समीक्षा के बाद, यदि आप 30 दिनों तक <strong>लगातार</strong> चैप्टर प्रकाशित करते है, तो आपको <strong>स्ट्रीक प्रोत्साहन</strong> (15 पैसे/शब्द) मिलना शुरू हो जाता है।<br/> 
        उदाहरण के लिए,<br/>
        -यदि आपने 1 अक्टूबर से 6 अक्टूबर तक प्रतिदिन 2500 शब्दों के अध्याय प्रकाशित किए हैं;<br/>
        तो 1 अक्टूबर से 30 अक्टूबर तक <strong>पूर्ण प्रोत्साहन</strong> राशि (10 पैसे / शब्द) मिलेगी, इसलिए प्रत्येक दिन ₹200। <br/>
        और 31 अक्टूबर से 2 नवंबर तक <strong>स्ट्रीक इंसेंटिव</strong>(15 पैसे/शब्द) मिलेगा, यानी हर दिन ₹300।<br/>
        -यह <strong>स्ट्रीक प्रोत्साहन</strong> तब तक जारी रहता है जब तक आप रोजाना चैप्टर पब्लिश नहीं करते।</>
      },
      {
        no: 4,
        text: <> यदि आप किसी दिन एपिसोड प्रकाशित करने से चूक जाते है, तो आपको अगले दिन आधी राशि मिलती है।<br/>
        उदाहरण के लिए,<br/>
        - यदि आप 1 जनवरी को एपिसोड प्रकाशन से चूक जाते है,<br/>
        तो आपको 2 जनवरी को प्रकाशित एपिसोड के लिए <strong>आधी प्रोत्साहन</strong> राशि (5 पैसे/शब्द) दी जाएगी। <br/>
        लेकिन आपको 3 जनवरी से फिर से <strong>फुल इंसेंटिव</strong>(10 पैसे/शब्द) ही मिलेगा।<br/>
        - यदि आप 1 से 3 जनवरी तक प्रकाशन से चूक जाते है, तो आपको <br/>
        तो आपको 4 से 6 जनवरी तक प्रकाशन के लिए <strong>आधी प्रोत्साहन</strong> राशि (5 पैसे/शब्द)<br />
        और 7 जनवरी से फिर से <strong>पूर्ण प्रोत्साहन</strong>  राशि (10 पैसे/शब्द) दी जाती है।</>,
      },
      {
        no: 5,
        text: <> यह पुरस्कार प्राप्त करना जारी रखने के लिए, प्रतिदिन अच्छी क्वालिटी एपिसोड अपलोड करें और सुनिश्चित करें कि वैलिड पाठक % एक एपिसोड से दूसरे एपिसोड में बहुत कम ना हो रहा हो। आप एनालिटिक्स सेक्शन में अपनी ऑडियो सीरीज़ का ग्राफ देख सकते है: एंगेजमेंट टैब</>,
      },
    ],
  },
  completion_bonus : {
    heading: '3. सीरीज़ कम्पलिट करने का बोनस  🚀',
    image: CompletionBonusDesktop,
    subHeading: 'आपकी  ऑडियो सीरीज़ पूरी हो जाने पर, यह इनाम लेखक को तब दिया जाएगा जब हमारे संपादकों द्वारा आपके नोवल की समीक्षा पूर्ण कर ली जाएगी।',
    tableHeadings: ['शब्द गणना (कुल)', 'इनाम 💰'],
    table: [
      {
        wordCount: '1,00,000 - 2,50,000',
        reward: '₹1,000',
      },
      {
        wordCount: '2,50,000 - 3,50,000',
        reward: '₹5000',
      },
      {
        wordCount: '3,50,000 - 5,00,000',
        reward: '₹10,000',
      },
      {
        wordCount: 'More than 5,00,000',
        reward: '₹25,000',
      },
    ],
    note: <>यदि आपके ऑडियो सीरीज़ से श्रोताओं काम हो जाते है, तो भी कम शब्द गणना के अंतर्गत इनाम अर्जित किया जा सकेगा। </>,
    extraNotes: [
      {
        no: 1,
        text: <> कृपया हमें writerassist@pocketfm.com पर विषय के साथ ईमेल करें: <strong>उपन्यास का नाम, लेखक का नाम,</strong> नोवल कम्पलिशन बोनस के लिए अनुरोध।</>,
      },
      {
        no: 2,
        text: <>हमारे संपादकों व्दारा कंटेंट गुणवत्ता मानकों के अनुरूप आपकी नोवल की जांच करने के बाद ही आपका भुगतान स्वीकृत किया जाएगा।</>,
      },
    ],
  },
  rewards_title: <>  🎁 पुरस्कार और लाभ 💸</>,
  rewards_para_text: <><span>👉पॉकेट नॉवेल के साथ जुड़कर अपने हरेक पुस्तक से आप साल के लगभग <strong> 1 लाख</strong> रुपए से लेकर <strong> 10 लाख </strong>रुपए तक कमा सकते हैं। </span> </>,
  deadline_content: <>   <span>कार्यक्रम में प्रवेश करने की समय सीमा:   </span><span role="img" aria-label="finish flag">🏁</span>   </>,
  deadline_to_enter_button: "पॉकेट नॉवेल राइटर बनें ",
  deadline_date: 1,
  deadlineDate: '1st',
  deadline_date_suffix: "",
  days_or: "दिन " ,
  months_to_go:"  महीने बाकी हैं! ",
  monthInWords:"जुलाई",
  month: 7,
  year: 2023,
  deadline_subheading: 'एक बार कार्यक्रम का हिस्सा बनने के बाद, आप जीवन भर के लिए उपरोक्त सभी बोनस के लिए पात्र होंगे',
  howItWorksArray : [
    {
      step: '1',
      instruction:<>पहले 30,000 शब्द लिखें और राइटर्स बेनिफिट प्रोग्राम के लिए आवेदन करें। ✍️</>,
        stepSVG: HowItWorksStep1SVG
    },
    {
      step: '2',
      instruction:<> यदि चुना जाता है, तो कॉन्ट्रैक्ट साइन करें और हर महीने रेवेन्यू शेयर के साथ नई कहानी का बोनस भी प्राप्त करें। </>,
        stepSVG: HowItWorksStep2SVG
  
    },
    {
      step: '3',
      instruction:<>एपिसोड को प्रतिदिन अपडेट करें, और हर महीने डेली अपडेट बोनस प्राप्त करें 💸 💰</>,
        stepSVG: HowItWorksStep3SVG
  
    }
  ],
  step: "चरण",
  popularWritersArray : [
    {
      writerName: 'Kavita verma',
      novelName: 'Mein Tere Chandani के लेखक',
      plays: '9.8M',
      words: '820K',
      writerImgSrc: KavitaImg,
    },
    {
      writerName: 'Words Queen',
      novelName: 'Fake Love  के लेखक',
      plays: '7.7M',
      words: '540K',
      writerImgSrc: WordsImg,
    },
    {
      writerName: 'Anand Usha Borkar',
      novelName: 'Megh - Ek Shraap  के लेखक',
      plays: '1.8M',
      words: '720K',
      writerImgSrc: AnandImg,
    },
  ],
  popular_writter: 'लोकप्रिय लेखक',


  faq: <strong>लगातार पूछे जाने वाले प्रश्न:-</strong>,
  
  write_home_earn_stable_income_text :'घर पर लिखें और स्थिर आय अर्जित करें।',
  write_home_earn_stable_income_subheading : "अपनी लेखन यात्रा अभी शुरू करें। लाखों पाठकों तक पहुंचें। प्रति पुस्तक प्रति वर्ष 10 लाख तक कमाएं।",
  create_new_novel :"एक नया उपन्यास बनाएँ ",
  WritingFAQs: [
    {
      question: '1. रजिस्टर कैसे करें और अपनी ऑडियो सीरीज़ कैसे बनाएं? ऑडियो सीरीज़ बनाने के लिए कुछ सुझाव?',
      answer: "कृपया इस वीडियो में दी गई प्रक्रिया को फॉलो करें: ",
      youtubeLink: 'https://d2ps1cw166f1t3.cloudfront.net/96bd3cf68da6389265041e5ace67015edc7b5794.mp4'
    },
    {
      question: '2. ऑडियो सीरीज़ प्रकाशित करने के लिए नियम और शर्तें क्या हैं?',
      answer: "केवल original fiction की कहानियों की अनुमति है। हम plagiarism ( copied content) और sexually explicit (adult content ) को निष्क्रिय करते हैं।",
    },
    {
      question: '3.  एक अध्याय प्रकाशित करने के लिए कितने शब्द चाहिए?',
      answer: "प्रत्येक अध्याय में कम से कम 1000 शब्द या अधिकतम 2500 शब्द होने चाहिए। इसे ऑडियो सीरीज़ को प्रकाशित करने के लिए प्लेटफ़ॉर्म पर उपलब्ध लेखक उपकरणों का उपयोग करके चैप्टर को ऑडियो एपिसोड में कन्वर्ट करें।",
    },
    {
      question: '4.  क्या मैं छोटी कहानियाँ या कविताएँ लिख सकता हूँ?',
      answer: "हमने देखा है कि किसी भी कविता या गैर-कल्पनाशील कहानी की तुलना में कल्पनाशील कहानियों में अधिक listeners होते हैं। इसलिए हम सभी लेखकों को original कल्पनाशील कहानियाँ लिखने की राये देते हैं। यदि हम लेखकों को छोटी कहानियाँ और कविताएँ लिखने की अनुमति देते भी हैं, तब भी  वह उन्हें Writers Benefit Program के लिए अप्लाई नहीं कर सकते।",
    },
    {
      question: '5. मैं कितनी भाषाओं में लिख सकता हूँ?',
      answer: "भारत में Pocket FM ऑडियो सीरीज को केवल हिंदी भाषा में लिखा जा सकता है। हम किसी अन्य भाषा में सामग्री स्वीकार नहीं करते हैं।",
    },
    {
      question: '6. मेरी ऑडियो सीरीज़ ऐप पर क्यों नहीं दिख रही है?',
      answer: "Pocket FM रोजाना सैकड़ों नई ऑडियो सीरीज़ publish करता है। हम उन ऑडियो सीरीज़ को अपनी featured list में शामिल कर सकते हैं जिनका अच्छा प्रदर्शन होता है। हमारे एप्लिकेशन में प्रमोशन के लिए सुनिश्चित करें कि आप नियमित रूप से एक लंबी कहानी लिख रहे हैं जिसमें एक आकर्षक प्लॉट लाइन है।",
    },
  ],
  ProgramFAQs: [
    {
      question: '1. Writers Benefit Contract पर हस्ताक्षर करने के लिए न्यूनतम परफॉरमेंस गाइडलाइन्स क्या हैं?',
      answer: "प्रोग्राम के लिए आवेदनों में से केवल शीर्ष 10% को स्वीकृत किया जाता है, कृपया सुनिश्चित करें कि आपके पाठक आपकी ऑडियो सीरीज़ के अध्यायों के साथ जुड़े हुए हैं।<br/> आप Analytics टैब -> Engagement -> valid reader % vs Chapter Graph पर जाकर प्लेटफॉर्म के average सीरीज़ डेटा के मुकाबले अपने सीरीज़ के प्रदर्शन का तुलना कर सकते हैं।",
    },
    {
      question: "2.मुझे Writer's Benefit Contract पर हस्ताक्षर क्यों करना है?",
      answer: "Writer’s Benefit Program (WBP) उन शर्तों और नियमों को शामिल करता है जिनका एक लेखक को पालन करना होता है अगर वह WBP में शामिल होना चाहते है। WBP के सभी लाभ और साहित्यिक प्रयासों के लिए भुगतान पाने के लिए, कॉन्ट्रैक्ट पर हस्ताक्षर करना बहुत महत्वपूर्ण होता है।",
    },
    {
      question: '3.कितने तरह के भुगतान उपलब्ध हैं?',
      answer: "Writer’s Benefit Program (WBP) के लिए चयन होने पर, लेखक को रिवेन्यू शेयर, न्यू नॉवेल बोनस, डेली अपडेट बोनस, और कम्प्लीशन बोनस प्राप्त हो सकता है। विस्तृत जानकारी के लिए Writer’s Benefit Program पर रिवेन्यू और incentive section में जाएं।",
    },
    {
      question: '4. भुगतान मिलने का क्या तरीका है?',
      answer: "आपका मुनाफा income टैब में दिखाई देगा। योग्य पेआउट को प्रति महीने के दूसरे सप्ताह में लेखक के संबंधित बैंक अकाउंट में जमा किया जाएगा",
    },
    {
      question: '5.  WBP में स्वीकृति मिलने के बाद, मुझे कितने दिनों तक लिखना होगा?',
      answer: "हमारे लेखकों के लिए क्वालिटी वाली सामग्री का एक नियमित प्रवाह अत्यंत महत्वपूर्ण है। डेली अपडेट बोनस को पाने के लिए रोज़ाना अध्याय अपलोड करना आवश्यक है। कृपया ध्यान दें कि कोई भी छूटे गए दिन, डेली अपडेट बोनस के बाहर की जाने की कारण होगी। आप विस्तृत जानकारी के लिए WBP पेज पर Revenue & Incentive section की संबंधित sections का संदर्भ ले सकते हैं।",
    },
    {
      question: '6. Pocket FM पर कोइंस क्या हैं?',
      answer: "कोइंस लेखकों का आर्थिक समर्थन करने के लिए उपयोग होते हैं। एक ऑडियो सीरीज़ के पहले कुछ एपिसोड को छोड़कर, बाकी सभी एपिसोड को सीमित समय के लिए लॉक लगी होती है। कोइंस इन एपिसोड को खोलने और पूरी कहानी का पहले से एक्सेस प्राप्त करने के लिए उपयोग किए जा सकते हैं। ",
    },
    {
      question: '7. कोइंस लेखकों को कैसे बेनिफिट करते है?',
      answer: "लेखकों को listeners के कोइंस खर्च पर कमाए गए Revenue का कम से कम 25% तक पहुंचता है।इस आय संरचना की अधिक विस्तृत जानकारी के लिए रेवेनुए शेयर कार्ड देखें",
    },
  ],
  PlatformFAQs: [
    {
      question: '1. Pocket FM ऐप कैसे डाउनलोड करें?',
      answer: `Pocket FM ऐप को App स्टोर (iOS) या Google Play Store (Android) से डाउनलोड कर सकते हैं।`,
    },
    {
      question: '2. मैं कैसे लॉगिन करूँ? ऐप का उपयोग कैसे करें?',
      answer: "कृपया इस वीडियो को देखें जिसमें एक विस्तृत विवरण है: ",
      youtubeLink: 'https://d2ps1cw166f1t3.cloudfront.net/371c42e1080c1933ffd0707b0466ce7cfd73a718.mp4'
    },
    {
      question: '3. एक एपिसोड कैसे Publish करें?',
      answer: "यदि आप हमारी प्लेटफ़ॉर्म पर किसी उपन्यास/ऑडियो सीरीज़ में एपिसोड जोड़ना चाहते हैं, तो आपको Pocket FM मोबाइल ऐप में लॉग इन करना होगा।",
    },
    {
      question: '4.  क्या मैं भारत के बाहर से लिख सकता/सकती हूँ?',
      answer: "हमारा एप्लिकेशन ग्लोबल रूप से उपलब्ध है। हम सभी देशों से लेखकों का स्वागत करते हैं। लेकिन हम वर्तमान में केवल भारत के लेखकों को ही पुरस्कार और धन प्रदान कर रहे हैं",
    },
    {
      question: '5. बुक कवर कैसे अपलोड करें?',
      answer: "Series पर जाएं और Edit Series option पे क्लिक करे। दाईं ओर, यहां बुक कवर छवि को अपडेट करने का एक option है। आप यहां बुक कवर अपलोड कर सकते हैं और ऑडियो सीरीज़ भी प्रकाशित कर सकते हैं। हमारी ग्राफिक टीम उच्च प्रदर्शन ऑडियो सीरीज़ के लिए एक विशेष बुक कवर बनाती है और यह Pocket FM द्वारा अपलोड किया जाती हैं।",
    },
    {
      question: '6. मैं क्यों अपने published एपिसोड को संपादित नहीं कर सकता/सकती?',
      answer: `जब एक ऑडियो सीरीज़ WBP का हिस्सा बनता है, "content restriction" option सक्रिय हो जाता है, जिसके तहत एक published एपिसोड को उसी दिन लेखक द्वारा edit किया जा सकता है।इसके बाद, यदि आप पहले से published एपीसोड में कोई नई परिवर्तन करना चाहते हैं, तो कृपया हमें <a href='mailto:writerassist@pocketfm.com'>writerassist@pocketfm.com</a> पर मेल के माध्यम से पूरा विवरण भेजें।`,
    },
  ],
  IssuesFAQs: [
    {
      question: '1. OTP प्राप्त नहीं हुआ या लॉगिन के दौरान समस्या हो रही है?',
      answer: "कृपया अपने पंजीकृत मोबाइल नंबर पर OTP फिर से प्रेषित करने का पुनः प्रयास करें। यदि समस्या अब भी बरकरार है, तो कृपया <a href='mailto:writerassist@pocketfm.com'>writerassist@pocketfm.com</a> पर एक ईमेल भेजें, जिसमें आपकी लॉगिन जानकारी जैसे पंजीकृत मोबाइल नंबर शामिल हो।",
    },
    {
      question: '2. ऐप काम नहीं कर रहा है, तो क्या करें?',
      answer: "अपने फोन को restart करें और अपडेट की जाँच करें। यदि आप फिर भी समस्या का सामना कर रहे हैं, तो अपने फोन की सेटिंग्स से 'PocketFM' ऐप को 'force stop' और app cache को साफ करने की कोशिश करें। यदि समस्या अब भी बरकरार है, तो <a href='mailto:writerassist@pocketfm.com'>writerassist@pocketfm.com</a> पर हमें एक समस्या के स्क्रीनशॉट/वीडियो के साथ ईमेल करें",
    },
  ],
}

// console.log(hindi.writer_dream_text)
export default hindiUGC;